// react
import React from 'react';

// components
import { PageTemplate } from '@/pwa/templates/PageTemplate/PageTemplate';
import { ModalPageTemplate } from '@/pwa/templates/ModalPageTemplate/ModalPageTemplate';
import { PageHeader } from '@/pwa/atoms/PageHeader/PageHeader';

// mui
import {
  Box,
  Button,
  CardMedia,
  Checkbox,
  FormControlLabel,
  Stack,
  Typography,
} from '@mui/material';

export interface ActionsCategoryItemProps {
  title: string;
  description: string;
  imageSrc?: string;
  bodyText?: string;
  contentSlot?: React.ReactNode;
  isComplete: boolean;
  checkboxLabel: string;
  isCheckboxChecked: boolean;
  onComplete: () => void;
  onCheckboxChange: (checked: boolean) => void;
  onBack: () => void;
  routeButton?: {
    label: string;
    onClick: () => void;
  };
  csatSlot?: React.ReactNode;
  isLoading?: boolean;
}

/**
 * ActionsCategoryItem is the single item detail page with image, text, and
 * complete button.
 */
export const ActionsCategoryItem = ({
  title,
  description,
  imageSrc,
  bodyText,
  contentSlot,
  isComplete,
  checkboxLabel,
  isCheckboxChecked,
  onComplete,
  onCheckboxChange,
  onBack,
  routeButton,
  csatSlot,
  isLoading,
}: ActionsCategoryItemProps) => {
  if (isLoading) return null;

  return (
    <ModalPageTemplate onBack={onBack}>
      <PageTemplate
        maxWidth='sm'
        headerSlot={<PageHeader title={title} description={description} />}
        contentSlot={
          <Stack spacing={3}>
            {contentSlot || <Typography variant='body1'>{bodyText}</Typography>}
            {routeButton && (
              <Button
                variant='contained'
                fullWidth
                onClick={routeButton.onClick}
              >
                {routeButton.label}
              </Button>
            )}
            <FormControlLabel
              control={
                <Checkbox
                  checked={isCheckboxChecked}
                  onChange={(e) => onCheckboxChange(e.target.checked)}
                  disabled={isComplete}
                />
              }
              label={isComplete ? 'Completed' : checkboxLabel}
            />
            {csatSlot}
            <Box
              sx={{
                flexGrow: 1,
              }}
            />
          </Stack>
        }
      />
    </ModalPageTemplate>
  );
};

ActionsCategoryItem.displayName = 'ActionsCategoryItem';

export default ActionsCategoryItem;
